<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">组织名称</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.vo_name" placeholder="请填写" />
          </div>
        </div>
      </div>

    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/document/virtual_org",
      form: {},
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.vo_name) {
        me.$weui.topTips("请填写名称", 2000);
      } else {
        me.f_save();
      }
    },
  },
}
</script>